"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.doTransform = exports.validatePyXlsx2Csv2Config = exports.parsePyExtractionParams = void 0;
const common_1 = require("@finley-technologies/common");
const parsePyExtractionParams = (transformation) => {
    const errors = [];
    let columns;
    let numRows;
    let headerRow;
    let headerRowNumber = null;
    let dataEndRowNumber = null;
    const { isSheetNameRegex, mode, headerRange, dataEndRange, sheetName, } = transformation;
    if (isSheetNameRegex) {
        errors.push(`SheetNameRegex is not supported in pyXlsx2Csv2.`);
    }
    if (mode !== 'convertRange') {
        errors.push(`Only convertRange is supported in pyXlsx2Csv2.`);
    }
    const [headerRangeStart, headerRangeEnd] = headerRange.split(':');
    if (headerRangeStart && headerRangeEnd) {
        const { c: headerStartCol, r: headerStartRow, } = common_1.utils.excelCoordsToNumberCoords(headerRangeStart);
        const { c: headerEndCol, r: headerEndRow, } = common_1.utils.excelCoordsToNumberCoords(headerRangeEnd);
        if (headerStartRow === headerEndRow) {
            headerRowNumber = headerStartRow;
            headerRow = headerStartRow;
        }
        else {
            errors.push('pyXlsx2Csv only supports headers in a single row.');
        }
        const headerStartColLetter = common_1.utils.numberToExcelLetter(headerStartCol);
        const headerEndColLetter = common_1.utils.numberToExcelLetter(headerEndCol);
        columns = `${headerStartColLetter}:${headerEndColLetter}`;
    }
    else {
        errors.push('Header range must be defined in format of A1:Z2');
    }
    if (dataEndRange) {
        const [dataEndRangeStart, dataEndRangeEnd] = dataEndRange.split(':');
        if (dataEndRangeStart && dataEndRangeEnd) {
            const { r: dataEndRangeStartRow } = common_1.utils.excelCoordsToNumberCoords(dataEndRangeStart);
            const { r: dataEndRangeEndRow } = common_1.utils.excelCoordsToNumberCoords(dataEndRangeEnd);
            if (dataEndRangeStartRow === dataEndRangeEndRow) {
                dataEndRowNumber = dataEndRangeStartRow;
            }
            else {
                errors.push('Data end range must be a single row.');
            }
        }
        else {
            errors.push('Data end range must be defined in format of A2:Z2.');
        }
    }
    if (typeof headerRowNumber === 'number' &&
        typeof dataEndRowNumber === 'number') {
        if (dataEndRowNumber >= headerRowNumber) {
            numRows = dataEndRowNumber - headerRowNumber;
        }
        else {
            errors.push(`[dataEndRowNumber:${dataEndRowNumber}] must be greater than or equal to [headerRowNumber:${headerRowNumber}]`);
        }
    }
    if (errors.length) {
        return {
            errors,
            isValid: false,
        };
    }
    return {
        isValid: true,
        pyXlxs2CsvExtractionParams: {
            sheetName,
            columns,
            numRows,
            headerRow,
        },
    };
};
exports.parsePyExtractionParams = parsePyExtractionParams;
const validatePyXlsx2Csv2Config = (transformation) => {
    const result = (0, exports.parsePyExtractionParams)(transformation);
    if (!result.isValid) {
        throw result.errors;
    }
    return null;
};
exports.validatePyXlsx2Csv2Config = validatePyXlsx2Csv2Config;
const doTransform = ({ srcDataTapeBuffer, transformation, pyXslx2CsvExtractor, }) => __awaiter(void 0, void 0, void 0, function* () {
    (0, common_1.finleyAssert)(pyXslx2CsvExtractor, 'pyXslx2CsvExtractor is required');
    const extractionParamsResult = (0, exports.parsePyExtractionParams)(transformation);
    if (!extractionParamsResult.isValid) {
        return {
            isValid: false,
            errors: extractionParamsResult.errors.map((err) => ({
                type: 'pyXlsx2Csv2',
                message: err,
            })),
        };
    }
    const res = yield pyXslx2CsvExtractor({
        extractionParams: extractionParamsResult.pyXlxs2CsvExtractionParams,
        xlsxBuffer: srcDataTapeBuffer,
    });
    return res;
});
exports.doTransform = doTransform;
exports.default = {
    parsePyExtractionParams: exports.parsePyExtractionParams,
    validatePyXlsx2Csv2Config: exports.validatePyXlsx2Csv2Config,
    doTransform: exports.doTransform,
};
//# sourceMappingURL=pyXlsx2Csv2-transform.js.map